import { useState } from 'react';
import { userReviews } from '@/mocks/home';

export default function ReviewsSection() {
  const [activeIndex, setActiveIndex] = useState(0);

  const review = userReviews[activeIndex];

  return (
    <section id="reviews" className="relative py-16 md:py-20 bg-background-50 overflow-hidden">
      <div className="w-full px-4 md:px-10">
        <div className="max-w-5xl mx-auto">
          <div className="relative rounded-3xl bg-primary-950 overflow-hidden">
            <div className="absolute top-0 left-0 w-48 h-48 opacity-[0.03] pointer-events-none">
              <svg viewBox="0 0 200 200" className="w-full h-full">
                <path
                  d="M20,180 Q60,100 100,60 Q140,20 180,40"
                  fill="none"
                  stroke="white"
                  strokeWidth="1.5"
                />
                <path
                  d="M10,170 Q70,90 120,50 Q160,10 190,30"
                  fill="none"
                  stroke="white"
                  strokeWidth="1"
                />
              </svg>
            </div>

            <div className="flex flex-col lg:flex-row">
              <div className="lg:w-2/5 relative min-h-[300px] md:min-h-[400px]">
                <img
                  src={review.avatar}
                  alt={review.name}
                  className="w-full h-full object-cover object-top rounded-t-3xl lg:rounded-l-3xl lg:rounded-tr-none"
                  title={`歪歪漫画用户 - ${review.name}`}
                />
                <div className="lg:hidden absolute inset-0 bg-gradient-to-t from-primary-950 via-transparent to-transparent"></div>
              </div>

              <div className="lg:w-3/5 p-8 md:p-10 lg:p-12 flex flex-col justify-center relative">
                <div className="text-7xl md:text-9xl font-serif text-accent-200/15 leading-none mb-4 select-none">
                  &ldquo;
                </div>
                <blockquote className="text-base md:text-lg text-background-50 leading-relaxed mb-6 relative z-10">
                  {review.quote}
                </blockquote>
                <div className="mt-2">
                  <p className="text-sm font-semibold text-background-50">{review.name}</p>
                  <p className="text-xs text-secondary-400 mt-0.5">{review.role}</p>
                </div>

                <div className="flex items-center gap-3 mt-8">
                  {userReviews.map((_, index) => (
                    <button
                      key={index}
                      onClick={() => setActiveIndex(index)}
                      className={`w-8 h-8 md:w-9 md:h-9 flex items-center justify-center rounded-full transition-all duration-300 cursor-pointer ${
                        index === activeIndex
                          ? 'bg-accent-500 text-background-50'
                          : 'bg-primary-800/60 text-secondary-400 hover:bg-primary-700/60'
                      }`}
                      aria-label={`Review ${index + 1}`}
                    >
                      <span className="text-xs font-medium">{index + 1}</span>
                    </button>
                  ))}

                  <button
                    onClick={() => setActiveIndex((activeIndex + 1) % userReviews.length)}
                    className="ml-auto px-4 py-2 rounded-full bg-accent-500 text-background-50 text-sm font-medium hover:bg-accent-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
                  >
                    下一条 <i className="ri-arrow-right-line ml-1"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}